import ConditionProperty from './ConditionProperty';
import ConditionVisibleControls from './ConditionVisibleControls';

export default class FrontendContextProperty extends ConditionProperty {
  public static override readonly label: string = 'Frontend Context Property';
  public static override readonly formFields: ConditionVisibleControls  = { fieldName: false, fieldPath: true, fieldIndex: false };
  public  static override readonly type: number = 11;

  public buildDescription(): string {
    const { path } = this.condition.options;
    return `Frontend context property [${path}] ${this.getOperatorLabel()} [${this.condition.value}]`;
  }
}
